import { createI18n } from "vue-i18n";
import EnLocale from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import enLocale from "./en";
import zhLocale from "./zh";
import storage from "@/utils/storage";

// 配置语言包
const messages = {
  en: {
    ...enLocale,
    ...EnLocale,
  },
  zh: {
    ...zhLocale,
    ...zhCn,
  },
};

// 创建 i18n 实例
const i18n = createI18n({
  // 设置语言 | 默认英文
  locale: storage.get("language") || "en",
  legacy: false, // 允许 Vue I18n 切换 API 模式，从 Legacy API 模式切换到 Composition API 模式。
  fallbackLocale: "en",
  // 设置语言包信息
  messages,
});

export default i18n;
